import { bindQuerySelector, jsx, setClassToken } from '@amazon/vinyl-tsx'
import { Icon } from '@/components/Icon'
import { Link } from '@/components/Link'
import { onNavigate } from '@/router/router'
import { clearSearch, showSearch } from '@/search/Search'

export function MobileBottomNav() {
    const view = (
        <nav className="mobileBottomNav" aria-label="Primary navigation">
            <Link
                className="mobileNavBtn homeMobBtn"
                href="/"
                onclick={clearSearch}
                navigateOptions={{ scroll: 'restore' }}
            >
                <Icon icon="homeFilled" />
                <span className="label">HOME</span>
            </Link>
            <button
                className="mobileNavBtn findMobBtn"
                onclick={() => {
                    showSearch()
                    // iOS Safari only opens the on-screen keyboard if focus()
                    // happens inside the user gesture. The header's search
                    // input is rendered with visible={signedIn()} so we focus
                    // it synchronously here while we still have the gesture.
                    const input = document.querySelector<HTMLInputElement>('#header .searchInput')
                    input?.focus()
                }}
            >
                <Icon icon="search" />
                <span className="label">FIND</span>
            </button>
            <Link className="mobileNavBtn myMusicMobBtn" href="/my/library" onclick={clearSearch}>
                <Icon icon="myMusic" />
                <span className="label">MY MUSIC</span>
            </Link>
            <button className="mobileNavBtn alexaMobBtn" disabled>
                <Icon icon="alexa" />
                <span className="label">ALEXA</span>
            </button>
        </nav>
    )

    const viewEl = bindQuerySelector(view)
    const homeBtn = viewEl('.homeMobBtn')
    const findBtn = viewEl('.findMobBtn')
    const myMusicBtn = viewEl('.myMusicMobBtn')

    onNavigate((event) => {
        const path = event.current
        const onHome = !path || path === '/'
        setClassToken(homeBtn, 'selected', onHome)
        setClassToken(findBtn, 'selected', path.startsWith('/search'))
        setClassToken(
            myMusicBtn,
            'selected',
            path.startsWith('/my/library') || path.startsWith('/library')
        )
    })

    return view
}
